import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorAccountSearch = () => {
  const accountSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/account-user/search', payload, (response) => {
      if (response.status_code === 200) {
        callback(response.data.items)
      } else {
        callback(null)
      }
      loading(false)
    })
  }, [])
  return { accountSearch }
}

export default InteractorAccountSearch
